import ready, { HTML } from 'Utils';
import initBurgerMenu from './components/initBurgerMenu';
import initCalcHeaderHeight from './components/initCalcHeaderHeight';
import initNavLinks from './components/initNavLinks';
import initUnderlineScale from './components/initUnderlineScale';
import initHeadingsDecor from './components/initHeadingsDecor';
import initImageScale from './components/initImageScale';
import initRandomPinPulse from './components/initRandomPinPulse';
import initFade from './components/initFade';
import initLottie from './components/initLottie';

ready(() => {
  HTML.classList.add('is-loaded');
});

// jQuery document ready
// jQuery(function() {
//   // init functions
// });

// vanilla document ready
document.addEventListener(
  'DOMContentLoaded',
  function () {
    initBurgerMenu();
    initCalcHeaderHeight();
    initNavLinks();
    initHeadingsDecor();
    initUnderlineScale();
    initImageScale();
    initRandomPinPulse();
    initFade();
    initLottie();
  },
  false
);
